import React, { useContext, useEffect, useState } from "react";
import { getStudentData } from "../../utilities/const/functions";
import { AuthContext } from "../../utilities/context/AuthContext";
import classes from "./AllAttendanceReport.module.css";
import AllAttendanceReportRemarksModal from "./AllAttendanceReportRemarksModal";
import IndividualAttendancePopUp from "./IndividualAttendancePopUp";
import { textEllipses } from "../../utilities/commonStyles/commonStyles";
export default function StudentRow({
  data,
  index,
  classData,
  fetchAtt,
  module,
  lessons,
  studentId,
  attendanceData,
}) {
  let arr = new Array(12).fill(0);
  const [studentData, setStudentData] = useState({ name: "", message: "" });
  const [attendance, setAttendance] = useState(arr);
  const [attendanceInfoData, setAttendanceInfoData] = useState([]);
  const { setLoading } = useContext(AuthContext);
  const [add, setAdd] = useState(false);
  const fetchStudentData = async () => {
    try {
      setLoading(true);
      const res = await getStudentData(studentId);
      if (!res.error) {
        setStudentData(res?.data);
      } else {
        window.alert(res.message);
      }
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const calcAttendanceInfoData = () => {
    let arr = [...attendanceData];
    let attArr = new Array(lessons.length).fill(0);
    // console.log({ arr });
    // console.log(lessons);
    arr.forEach((e) => {
      //   console.log({ e });
      // let d = new Date(e?.date?.seconds * 1000);
      // var date = d.getDate();
      // var day = d.getDay();
      // var weekOfMonth = Math.ceil((date - 1 - day) / 7);
      // //   console.log({ date: d.toDateString() });
      // //   console.log(d.getMonth() + 1, " ", weekOfMonth + 1);
      // let passedWeek = (d.getMonth() % 3) * 4;
      // let position = passedWeek + weekOfMonth;
      let position = lessons.map((ele) => ele.id).indexOf(e.lessonId);

      // let position = lessons.indexOf(e.lessonId);
      // console.log({ e });

      // console.log({ position });
      let presentStatus = e.replacementStatus
        ? "R"
        : e.presentStatus
        ? "P"
        : "A";
      // console.log({ position });
      // console.log({ presentStatus });
      // console.log({ lesson: e.lessonId });
      // console.log({ studentId: e.studentId });
      // console.log(" ");
      attArr[position] = { ...e, status: presentStatus };
      //   console.log({
      //     passedWeek,
      //     position,
      //   });
    });
    // console.log({ attArr });
    setAttendance(attArr);
    setAttendanceInfoData(arr);
  };
  //   console.log({ studentData });
  useEffect(() => {
    setStudentData({ name: "", message: "" });
    calcAttendanceInfoData();
    fetchStudentData();
  }, [studentId, add]);

  //   console.log({ attendanceData });
  return (
    <>
      {/* <button onClick={() => console.log({ attendanceInfoData })}>Click</button> */}
      {/* <button onClick={calcAttendanceInfoData}>Click</button> */}
      <tr>
        <td
          // className={classes.infoDetails}
          style={{
            backgroundColor: data?.dropped ? "#FF8787" : "",
            width: "60px",
            maxWidth: "60px",
            ...textEllipses,
          }}
        >
          {index + 1}
        </td>
        <td
          // className={classes.infoDetails}
          style={{
            width: "90px",
            maxWidth: "90px",
            backgroundColor: data?.dropped ? "#FF8787" : "",
            ...textEllipses,
          }}
        >
          {studentData?.id}
        </td>
        <td
          // className={classes.infoDetails}
          style={{
            width: "250px",
            maxWidth: "250px",
            backgroundColor: data?.dropped ? "#FF8787" : "",
            textAlign: "left",
            ...textEllipses,
          }}
        >
          {studentData?.name}
        </td>
        <td
          className={classes.remark}
          style={{
            width: "100px",
            maxWidth: "100px",
            backgroundColor: data?.dropped ? "#FF8787" : "",
          }}
        >
          <AllAttendanceReportRemarksModal
            setAdd={setAdd}
            admissionData={data}
            data={studentData}
          />
        </td>
        {/* "R" "P", "A", 0  */}
        {attendance
          ?.slice(module * 3 * 4, (module + 1) * 3 * 4)
          .map((e, index) => (
            // <td
            //   key={index}
            //   style={{
            //     cursor: "pointer",
            //   }}
            //   className={
            //     e == 0
            //       ? classes.pending
            //       : e == "A"
            //       ? classes.absent
            //       : e == "R"
            //       ? classes.replacement
            //       : classes.present
            //   }
            // >
            //   {e == "R" ? e : ""}
            // </td>
            <IndividualAttendancePopUp
              index={index}
              dropped={data?.dropped}
              classData={classData}
              key={e.id}
              data={e}
              fetchAtt={fetchAtt}
              studentData={studentData}
              lessons={lessons}
              module={module}
            />
          ))}
      </tr>
    </>
  );
}
